module.exports = __webpack_public_path__ + "static/media/phone-icon-navbar.3075c151.svg";